/**
 * Цветовая палитра 3CupsGames: фиолетовые/пурпурные неоновые акценты
 */

export const COLORS = {
  backgroundDark: 0x0a0612,
  backgroundGradientTop: 0x1a0a2e,
  backgroundGradientBottom: 0x0d0218,
  purple: 0x9d4edd,
  purpleLight: 0xc77dff,
  purplePale: 0xe0aaff,
  neonBlue: 0x4cc9f0,
  gold: 0xffd700,
  white: 0xffffff,
  gray: 0x6b6b6b,
  grayDark: 0x3a3a3a,
  red: 0xcc2244,
  green: 0x22cc66,
  buttonPrimary: 0x7b2cbf,
  buttonPrimaryHover: 0x9d4edd,
  buttonSecondary: 0x4a4a4a,
  textPrimary: 0xffffff,
  textSecondary: 0xb0a0c0,
  /** Более яркий текст для правой панели (кнопки, подписи) */
  textPanel: 0xe0d4f0,
  demoMode: 0x9d4edd,
} as const;
